import { useI18n } from "../../i18n/localization";

// Post-call summary (docs/design/05-uiux-spec.md §3.7).
export function CallEnded({ reason, onBack }: { reason: string | null; onBack: () => void }) {
  const { t, dir, messageFor } = useI18n();
  return (
    <main style={center} dir={dir}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 18, color: "#14305f", marginBottom: 10 }}>{t.call.endedTitle}</div>
        {reason && <div style={{ fontSize: 13, color: "#64748b", marginBottom: 24 }}>{reasonText(reason, messageFor)}</div>}
        <button onClick={onBack} style={btn}>{t.call.backToList}</button>
      </div>
    </main>
  );
}

function reasonText(reason: string, messageFor: (code: string) => string): string {
  switch (reason) {
    case "no-answer": return messageFor("VC-CALL-002");
    case "reconnect-timeout": return messageFor("VC-MEDIA-003");
    default: return "";
  }
}

const center: React.CSSProperties = {
  height: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
  fontFamily: "Segoe UI, Arial, sans-serif", background: "#eef2f7"
};
const btn: React.CSSProperties = {
  background: "#1d4ed8", color: "#fff", border: "none", borderRadius: 6, padding: "8px 22px", fontSize: 14, cursor: "pointer"
};
